module.exports = __webpack_public_path__ + "static/media/schk_web_footer_logo_schk_n_NA.82d1731d.png";